<template>
<div class="card">
    <div class="card-header">Complete</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="15"/>
        
        <div v-if="request.completed">
            <b-row>
                <b-col>
                    <b-alert show>This request has been completed.</b-alert>
                </b-col>
            </b-row>
        </div>
        <div v-else>
            <b-form @submit.stop.prevent="onSubmit">
                <b-row>
                    <b-col>
                        <LifecycleCheckList lifecycleStatus="15" :requestId="request.id"
                            v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                    </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" lg="6">
                    <BaseTextOutput :value="request.selectedCandidateName"
                                    label="New Employee Name"/>
                  </b-col>

                  <b-col cols="12" lg="6">
                    <BaseDateInput v-model="request.effectiveStartDate"
                                   :v="$v.request.effectiveStartDate"
                                   label="Effective Start Date"
                                   slug="start-date"/>
                  </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <BaseParagraphInput v-model="comments"
                            :v="$v.comments"
                            slug="finalComments"
                            label="Internal Comments"
                            :required="$v.comments.$params.required"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-table hover small show-empty
                                 responsive="true"
                                 :fields="leaveCommentFields"
                                 :items="request.leaveComments"
                                 :busy="false">
                            <template v-slot:no-data>
                                No Request Returned Comments Found.
                            </template>
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                            <template slot="empty" slot-scope="scope">
                                No Request Returned Comments Found.
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
                <div>
                <b-button type="submit" variant="primary">Complete HR Request</b-button>
                <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
                </div>
            </b-form>
        </div>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import { tableFields } from '@/mixins/tableFields.js'
import BaseDateInput from "@/components/BaseDateInput.vue";

export default {
    components: {
        LifecycleCheckList,
        BaseDateInput
    },
    mixins: [
        tableFields
    ],
    props: {
        request: Object
    },
    data() {
        return { 
            checklistComplete: false,
            comments: ''
        }
    },
     validations: {
         comments: { required: false, maxLength: maxLength(4000) },
         checklistComplete: { checked: value => value === true },
         request: {
           effectiveStartDate: { required },
         }
     },
    
    computed: {
    },

    created() {
      if(this.request.finalComments){
        this.comments = this.request.finalComments
      }
    },
    
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },
        save() {
          this.saveOnly = true
          this.onSubmit()
          this.saveOnly = false
        },
        onSubmit() {
          if (!this.saveOnly) {
            this.$refs.checklist.emitCheckListStatus()
            this.$v.$touch();
            if (this.$v.$invalid) {
              this.$nextTick(() => {
                document.getElementById('form-container').scrollIntoView()
              })
              return
            }
          }

            let payload = {
                requestId: this.request.id,
                advanceNextLifecycle: !this.saveOnly,
                effectiveStartDate: this.request.effectiveStartDate,

                comments: this.comments
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/complete`, payload)
                  .then(response => {                       
                    this.showRootToast("Posted Submitted", "updated.", "success")
                    this.$router.push('/home')
                  })
                  
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
    }   
}
</script>